"use strict";
import _ from "underscore";
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import rootReducer from "./reducers";
import createLogger from "redux-logger";
import { Action } from "./actions";
const logger = createLogger({
  predicate: (getState, action) => {
    return __DEV__ && _.all(
      [Action.ADDING_MOVED, Action.MOVING_MOVED, Action.MOUSE_MOVED],
      (t) => t !== action.type
    );
  },
  collapsed: true
});
const createStoreWithMiddleware = applyMiddleware(
  thunkMiddleware,
  logger
)(createStore);
export default function configureStore() {
  return createStoreWithMiddleware(rootReducer);
}
